Revolution.Module.extend({
  NAME: "mde.side-container", // OBLIGATOIRE (reflète l'arborescence répertoire : /mde/main.js)

  initialize: function ($) {
    $('.js-side-container, .trigger-side-container').css('top', $('header').outerHeight() + $('.bk-banner').outerHeight() + 40);
    var controller = new ScrollMagic.Controller();
    new ScrollMagic.Scene({triggerElement: ".trigger-side-container"})
        .setPin(".js-side-container")
        .addTo(controller);
  },

  onWindowLoad: function (e) {

  },

  onWindowScroll: function (e) {

  },
  onWindowResize: function (e) {

  },
});
